import React from "react";
import PropTypes from "prop-types";

/* eslint-disable jsx-a11y/label-has-for */
const InputField = ({ name, value, label, onInputChange }) => (
  <div className={`form-item form-item--${name}`}>
    <label className="form-required" htmlFor={name}>
      {label}:
    </label>
    <textarea
      name={name}
      className="comments-form__item"
      id={name}
      value={value}
      onChange={(e) => onInputChange(e.target.name, e.target.value)}
      rows="5"
      maxLength="500"
      required
    />
  </div>
);

InputField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

InputField.defaultProps = {
  value: "",
};

export default InputField;
